// this file is automatically generated by git.version.ts script
export const appVersion = {
  version: '1.1.2',
  revision: 'd5b768f',
  branch: 'HEAD'
}



// WEBPACK FOOTER //
// ./src/environments/versions.ts